module.exports = __webpack_public_path__ + "img/fireship64_ua.48d419cb.webp";